module.exports = __webpack_public_path__ + "media/images/icons/rotate_right-7068dafa6e492c7871dfaa3a7d188f99.svg";